import type { ReactElement } from 'react';
import { ORDER_INQUIRY_POLICY_INTRO, ORDER_INQUIRY_POLICY_RULES } from './order-inquiry-policy';

/** 교환·환불 기준 안내 — 소개 문장과 기준 목록. */
export const OrderInquiryPolicyNotice = (): ReactElement => (
  <div className="flex flex-col gap-3">
    <p className="text-xs leading-relaxed text-muted-foreground">{ORDER_INQUIRY_POLICY_INTRO}</p>
    <ul className="flex list-disc flex-col gap-1 pl-4 text-xs leading-relaxed text-muted-foreground">
      {ORDER_INQUIRY_POLICY_RULES.map((rule) => (
        <li key={rule}>{rule}</li>
      ))}
    </ul>
  </div>
);
